import * as React from "react";
import { observer } from "mobx-react";
import { locKeys } from "components/flexComponents/WizardHotelPWA/components/l10n";
import { UitkCheckbox } from "uitk-react-switch";
import { HotelWizardStateProps } from "components/flexComponents/WizardHotelPWAv2/typings";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { Action, FlexTrackingInfo, sendDelayedTrackEvent } from "components/utility/analytics/FlexAnalyticsUtils";
import { AnalyticsStore } from "bernie-core";

export interface HotelAddFlightCheckboxProps extends HotelWizardStateProps {
  onChange: () => void;
  updatePackageOnReflection?: () => void;
  analytics: AnalyticsStore | undefined;
}

export const HotelAddFlightCheckbox = observer(
  ({ hotelWizardState, onChange, updatePackageOnReflection, analytics }: HotelAddFlightCheckboxProps) => {
    const { formatText } = useLocalization();

    const rfrrAddCarCheckbox = "SoftPackage_Flight";
    const moduleName = "WizardHotelPWAv2";

    const getAddCarCheckboxTrackingInfo = (rfrr: string): FlexTrackingInfo => {
      return {
        moduleName,
        action: Action.CLICK,
        rfrr,
      };
    };

    const handleChange = () => {
      hotelWizardState.toggleAddAFlightCheckbox();
      onChange();

      if (updatePackageOnReflection) {
        updatePackageOnReflection();
      }

      sendDelayedTrackEvent(getAddCarCheckboxTrackingInfo(rfrrAddCarCheckbox), analytics);
    };

    return (
      <UitkLayoutFlexItem>
        <UitkCheckbox
          id="add-flight-switch"
          name="add-flight-switch"
          value={String(hotelWizardState.isAddAFlightChecked)}
          checked={hotelWizardState.isAddAFlightChecked}
          onChange={handleChange}
          disabled={hotelWizardState.isMultiplePlacesChecked}
        >
          {formatText(locKeys.addFlightLabel)}
        </UitkCheckbox>
      </UitkLayoutFlexItem>
    );
  }
);
